// CustomerGeneral.jsx
import css from './CustomerGeneral.module.css';

function CustomerGeneral({ data, toggleModal }) {
    if (!data) return null;

    return (
        <div className={css.card}>
            <h2>Customer Overview</h2>
            <div className={css.info}></div>

            <h2 className={css.h2}>General</h2>
            <div className={css.details}>
                {/* <div
                        className={css.image}
                        style={{
                            backgroundImage: `${logo[data.courseAircraftTypeId]}`,
                        }}
                    ></div> */}
                <div>
                    <p>
                        <strong>Name:</strong> {data.customerName}
                    </p>
                    <p>
                        <strong>VAT:</strong> {data.customerVAT}
                    </p>
                    <p>
                        <strong>Type:</strong> {data.customerType}
                    </p>
                    <p>
                        <strong>Active:</strong> {data.customerIsActive ? 'Yes' : 'No'}
                    </p>
                    <p>
                        <strong>Short Name:</strong> {data.customerNameShort}
                    </p>

                    <button className={css.editButton} onClick={toggleModal}>
                        Edit
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CustomerGeneral;
